import { render, staticRenderFns } from "./TitleSection.vue?vue&type=template&id=7bc16f04&scoped=true&"
import script from "./TitleSection.vue?vue&type=script&lang=ts&"
export * from "./TitleSection.vue?vue&type=script&lang=ts&"
import style0 from "./TitleSection.vue?vue&type=style&index=0&id=7bc16f04&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc16f04",
  null
  
)

export default component.exports